import React, { memo } from 'react';
import { Link } from 'react-router-dom';

const categoryNames = {
  'peptides': 'Peptides',
  'anabolic-steroids': 'Anabolic Steroids',
  'sarms-and-related-compounds': 'SARMs and related compounds',
  'serms-and-related-compounds': 'SERMs and related compounds',
  'sexual-health': 'Sexual health',
  'harm-reduction': 'Harm reduction',
  'others': 'Others'
};

const ProductCard = memo(function ProductCard({ product }) {
  return (
    <div className="product-card" data-testid={`product-card-${product.slug}`}>
      <Link to={`/pricelist/${product.slug}`}>
        <div className="product-card-image">
          <img src={product.image_url} alt={product.name} loading="lazy" decoding="async" />
        </div>
      </Link>
      <div className="product-card-info">
        <div className="product-card-category">
          {categoryNames[product.category] || product.category}
        </div>
        <Link to={`/pricelist/${product.slug}`}>
          <h5 className="product-card-title">{product.name}</h5>
        </Link>
        <div className="product-card-price">{product.price} $</div>
        <Link to={`/pricelist/${product.slug}`} className="btn-order" data-testid={`order-btn-${product.slug}`}>
          Order now
        </Link>
      </div>
    </div>
  );
});

export default ProductCard;
